// Determine environment based on hostname
const isDev = window.location.hostname === 'localhost' || 
              window.location.hostname.includes('127.0.0.1');

// Dev configuration
const devConfig = {
  BACKEND_URL: "https://dev.visiongames.ai",
  STRIPE_PUBLISHABLE_KEY: "pk_test_51Skwt90JCObAicfEhNW7vAQ1cOg7Ot56okTY5xf2gjH5cmnmB6sUaf1qKlhVlzbSOn2eBrSAkOXBcvIYMjIPikc100geKjJaxN",
  // USD Prices (Test mode)
  STRIPE_PRICE_MONTHLY: "price_1Sobl40JCObAicfE3km0KGCU",
  STRIPE_PRICE_ANNUAL: "price_1SobkA0JCObAicfEbp6R9DB3",
  // INR Prices (Test mode)
  STRIPE_PRICE_MONTHLY_INR: 'price_1Slhhb0JCObAicfEIhxv3y2i',
  STRIPE_PRICE_ANNUAL_INR: 'price_1Slhi80JCObAicfEMtBKK6Mb',
};

// Prod configuration - TODO: Add your production values
const prodConfig = {
  BACKEND_URL: "https://vision-games-be-production.up.railway.app",
  STRIPE_PUBLISHABLE_KEY: "pk_live_51Skwsx0Q7WFCVdwY9Uan7eokpcv4OpbRiMKyBhGBkyLRFv2qIKPL6h8ns9GcPBYrQ3e5WrZlqfjmgLWBGMaFwxsr00EssigAXd",
  // USD Prices (Live mode)
  STRIPE_PRICE_MONTHLY: "price_1Soc0H0Q7WFCVdwYa63ZzUGl",
  STRIPE_PRICE_ANNUAL: "price_1SkzZx0Q7WFCVdwYGaEnDhaa",
  // INR Prices (Live mode)
  STRIPE_PRICE_MONTHLY_INR: 'price_1Soc0n0Q7WFCVdwY28GIoPU6',
  STRIPE_PRICE_ANNUAL_INR: 'price_1Slhg90Q7WFCVdwY1n7TUy3u',
};

// Select config based on environment
export const config = isDev ? devConfig : prodConfig;

// Optional: Log which environment is being used
console.log(`Config loaded for ${isDev ? 'DEVELOPMENT' : 'PRODUCTION'} mode`);
